import { BrokerageOfferingPostRequestBody, BrokerageOfferingPostResponse } from '@lio/api-types';
import { offeringKeys } from '@services/brokerage/offering/offering.keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateBrokerageOffering = (brokerageId: string) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: BrokerageOfferingPostRequestBody) =>
      client
        .post(`brokerage/${brokerageId}/brokerage-offering`, {
          json: {
            ...body,
          },
        })
        .json<BrokerageOfferingPostResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offeringKeys.brokerageOfferingsSearch });
    },
  });
  return { ...result, createBrokerageOffering: result.mutateAsync };
};
